<!-- 新竹单号管理 -->
<template>
  <div>
        <ctrl-box class="ctrl-box" :data="{}">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="list(true)">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shuaxin1" font-size="27px;"/>
                            <span class="txt" >{{msg('刷新')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="importData()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daoru3" font-size="27px;"/>
                            <span class="txt" >{{msg('导入')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doDelete()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                            <span class="txt">{{msg('删除')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('新竹单号')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.codes" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('调用订单')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.refCodes" ></el-input>
                    </el-form-item>
                    <el-form-item :label="msg('创建时间')">
                        <el-date-picker
                            v-model="scope.query.Date"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                            :range-separator="msg('至')"
                            :start-placeholder="msg('开始日期')"
                            :end-placeholder="msg('结束日期')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="msg('使用时间')">
                        <el-date-picker
                            v-model="scope.query.usedTime"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            clearable
                            :range-separator="msg('至')"
                            :start-placeholder="msg('开始日期')"
                            :end-placeholder="msg('结束日期')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item :label="msg('状态')">
                        <el-select v-model="scope.query.status" placeholder="请选择">
                            <el-option label="已使用" value="1"></el-option>
                            <el-option label="未使用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list(true)" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                resizable border="full"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="datas"
                :columns="columns"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

        <el-dialog
            :title="msg('导入新竹单号')" :fullscreen="isMinScreen"
            :visible.sync="importVisible"
            :close-on-click-modal="false"
            :before-close="doCloseImport"
            width="400px">
            <el-row :gutter="10"  class="ctrl-wrap">
                <el-col :sm="24" :md="12">
                    <el-button size="mini"
                        @click="doSelectFile()" type="success" 
                        style="margin-right:5px; margin-bottom:5px;">
                            <i class="iconfont icon-xuanzewenjian" 
                                style="display:inline-block;margin-right:4px;"></i>
                            <transition name="el-fade-in-linear">
                                <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                            </transition>
                    </el-button>
                    <div ref="fileArea" style="display:none;">
                    </div>
                </el-col>
                <el-col :sm="24" :md="12">
                    <el-button size="mini"
                        @click="doDownloadTpl()" type="primary" 
                        style="margin-right:5px; margin-bottom:5px;">
                            <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                            <transition name="el-fade-in-linear">
                                <span v-show="!isMinScreen">{{msg('下载模板')}}</span>
                            </transition>
                    </el-button>
                </el-col>  
            </el-row>
        </el-dialog>

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import XLSX from "xlsx";
export default {
    name: 'OrderCode',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
    },
    mounted:function(){
        this.buildColumns();
        this.list();
    },
    data(){
        return {
            query:{
                length: 20,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
                codes: null,
                refCodes: null,
                usedTime: [],
                Date:[],
                status: null,
            },
            showQuery: false,
            columns: [],
            datas: [],
            dgTitle: '',
            importVisible: false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
            return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 60},
                {field: 'id', title: this.msg('ID'), minWidth: 80, sortable: true},
                {field: 'code', title: this.msg('新竹单号'), minWidth: 150, sortable: true},
                {field: 'status', title: this.msg('状态'), minWidth: 150, sortable: true,
                    slots: {
                        default: ({ row }) => {
                            let status = row.status;
                            return [
                                <el-tag type={status=='1'?'danger':'success'}>{status=='1'?'已使用':'未使用'}</el-tag>
                            ];
                        },
                    }
                },
                {field: 'refCode', title: this.msg('调用单号'), minWidth: 150, sortable: true},
                {field: 'usedTime', title: this.msg('使用时间'), minWidth: 150, sortable: true},
                {field: 'fullname', title: this.msg('创建人'), minWidth:130, sortable: true},
                {field: 'created', title: this.msg('创建时间'), minWidth: 130, sortable: true},
                {field: 'groupName', title: this.msg('物流商'), minWidth: 130, sortable: true},
            ]
        },
        //查询新竹单号列表
        list(refresh){

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }
            
            if(this.query.codes){
                let cs = this.query.codes.split(/\s+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                this.query["codes"] = css.join(",");
            }else{
                this.query["codes"] = '';
            }
            
            if(this.query.refCodes){
                let cs = this.query.refCodes.split(/\s+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                this.query["refCodes"] = css.join(",");
            }else{
                this.query["refCodes"] = '';
            }

            var param = this.$kit.rebuildQuery(this.query);

            this.$axios.post(this.$kit.api.orderCode.list, param)
                .then((result) => {
                    if(result.status){
                        this.datas = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            var _this = this;
            this.$confirm('确定要删除选择的订单吗?', this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.orderCode.delete, selectes.map(e => e.id).join(","))
                .then((result) => {
                    _this.$message(result.msg || _this.msg('删除成功'));
                    _this.list();
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        doExport(){
            this.$refs.dataTable.exportData({ filename:"订单号",type: 'csv' })
        },
        importData(){
            this.importVisible = true;
        },
        doCloseImport(){
            this.importVisible = false;
        },
        doSelectFile(){  //点击选择文件
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            input.onchange = this.getUploadFile;
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {  //解析上传的excel
            let that = this;

            this.excelData = null
            //拿到所导入文件的名字
            let fileName = e.target.files[0];
            //定义reader，存放文件读取方法
            let reader = new FileReader();
            //启动函数
            reader.readAsBinaryString(fileName)
            //onload在文件被读取时自动触发
            reader.onload = (e) => {
                //workbook存放excel的所有基本信息
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                let sheetList = workbook.SheetNames
                //存放json数组格式的表格数据
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                that.excelData = json.splice(1);
                that.excelHeads = heads;
                that.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        doUpload(){
            this.$axios.post(this.$kit.api.orderCode.doImport, this.excelData)
                .then((result) => {
                    if(result.status){
                        this.$message({
                            type:'success',
                            message:result.msg || this.msg('导入成功')
                        });
                        this.$alert(result.msg, this.msg('提示'), {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.importVisible = false;
                                this.list(true);
                            }
                        });
                    }
                });
        },
        doDownloadTpl(){  //下载一个excel模板，
           
            var titles = [['新竹单号'],[],[],[]];
 
            var filename = '新竹单号导入模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
    },
}
</script>

<style lang="scss" scoped>
.nav-tag span{
  margin:0px 10px 5px 0px;
  cursor: pointer;
}
</style>
